export default {
    name: 'neighborhoodProfileService',
    dependencies: ['xhrservice', 'trackingservice'],
    callable(xhrservice, trackingService) {
        let promise;

        return function(profileUrl) {
            if (promise) {
                return promise;
            }

            const adId = new URL(document.baseURI).searchParams.get('finnkode');
            const url = new URL(`${profileUrl}.html`, document.baseURI);
            url.searchParams.set('finnkode', adId);
            promise = xhrservice.request({
                url: url.href,
            });
            promise.then(data => {
                const hasRatings = data.indexOf('data-nb-ratings') > -1;
                if (hasRatings) {
                    trackingService.trackEvent(
                        'other.neighborhood-ratings-load',
                        'start',
                        ''
                    );
                } else {
                    trackingService.trackEvent(
                        'other.neighborhood-load',
                        'start',
                        ''
                    );
                }
            });
            return promise;
        };
    },
};



// WEBPACK FOOTER //
// ./services/neighborhoodProfileService.js